export default __webpack_public_path__ + "static/media/CNo.71-6.06d17eee.jpg";